export enum RiskSystemResultType {
  ACCEPTED = "Accepted",
  ADD = "Add",
  DOS_MATCH_ONLY = "DOS_MATCH_ONLY",
  MATCH = "MATCH",
  NO_MATCH = "NO_MATCH",
}
